(() => {
  "use strict";


  // ====================================================
  // CURRENT PRODUCT HANDLE
  // ====================================================

  const prodHandle = location.pathname.split("/").pop();


  // ====================================================
  // PRODUCT GROUPS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];

    // ====================================================
  // HELPER
  // ====================================================

  function createBanner(
    img,
    title,
    desc,
    extra = "",
    freeTag = "FURTHER PRICE DROPS"
  ) {

    const wrapper = document.createElement("div");

    wrapper.className = "free_gift_banner layout2";

    wrapper.innerHTML = `
      <div class="free-gift comex">

        <img src="${img}" alt="">

        <div class="info-wrapper">

          <div class="title-wrapper">
            <span class="free-tag">${freeTag}</span>
            <span class="title">${title}</span>
          </div>

          ${
            desc
              ? `<p class="description">${desc}</p>`
              : ""
          }

          ${
            extra
              ? `<span class="description red">${extra}</span>`
              : ""
          }

        </div>

      </div>
    `;

    return wrapper;
  }


  // ====================================================
  // BANNERS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  function getCeilingFanWarrantyBanner() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs_Desktop_cd7a14f0-d8da-4b5b-9180-85c8e15f33f1.png?v=1780035893",
        "$50 drop across all Smart Models",
        "For all Oasis smart models",
        "Offer Ends 3 October"
    );

  }

  // ====================================================
  // PROMOTION LOGIC
  // ====================================================

  let banner = null;


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  if (ceilingFanProducts.includes(prodHandle)) {

    banner = getCeilingFanWarrantyBanner();


  // ----------------------------------------------------
  // TV - FREE RIPPLE
  // ----------------------------------------------------

  }

    // ====================================================
  // STOP IF NO PROMOTION
  // ====================================================

  if (!banner) return;


  // ====================================================
  // INJECT BANNER
  // ====================================================

  function inject() {

    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target || !target.parentNode) {
      return;
    }

    target.parentNode.insertBefore(
      banner,
      target
    );

  }

    // ====================================================
  // DOM READY
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      inject
    );

  } else {

    inject();

  }
})();